import { create } from 'zustand';
import { ToastDefinition } from './types';

export interface ToastStore {
  /**
   * The list of active toast messages
   */
  toasts: ToastDefinition[];

  /**
   * Add a new toast message
   */
  add: (toast: ToastDefinition) => void;

  /**
   * Remove an existing toast message
   */
  remove: (id: string) => void;
}

export const useToastStore = create<ToastStore>(set => ({
  toasts: [],
  add: toast =>
    set(s => {
      const isDuplicate = s.toasts.some(
        t => t.message === toast.message && t.severity === toast.severity
      );

      if (isDuplicate) {
        return s;
      }

      return {
        toasts: [
          ...s.toasts,
          { ...toast, id: Math.round(Math.random() * 1000000).toString() }
        ]
      };
    }),
  remove: id => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }))
}));
